import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { computed, observable } from 'mobx';
import Video from '@src/components/video';
import AntdMessage from '@src/components/antd/message';

class SectIntroductionStore extends BaseStore {
  @observable swiperRef = null;
  @observable
  sectList = {
    wudu: {
      title: require('./images/wudu/title.png'),
      subTitle: require('./images/wudu/sub-title.png'),
      radar: require('./images/wudu/radar.png'),
      desc: require('./images/wudu/sect-desc.png'),
      weapon: require('./images/wudu/weapon.png'),
      // role: 'https://static-jxqy.seasungames.cn/uploads/202504/1746017360494_jiange.png',
      role: require('./images/wudu/wu_du_ren_wu.png'),
      pagination: require('./images/sect-wudu.png'),
      paginationAcitve: require('./images/sect-wudu-active.png'),
      videoUrl: ''
    },
    jiange: {
      title: require('./images/jiange/title.png'),
      subTitle: require('./images/jiange/sub-title.png'),
      radar: require('./images/jiange/radar.png'),
      desc: require('./images/jiange/sect-desc.png'),
      weapon: require('./images/jiange/weapon.png'),
      role: 'https://static-jxqy.seasungames.cn/uploads/202504/1746017360494_jiange.png',
      pagination: require('./images/sect-jiange.png'),
      paginationAcitve: require('./images/sect-jiange-active.png'),
      videoUrl: ''
    },
    yunni: {
      title: require('./images/yunni/title.png'),
      subTitle: require('./images/yunni/sub-title.png'),
      radar: require('./images/yunni/radar.png'),
      desc: require('./images/yunni/sect-desc.png'),
      weapon: require('./images/yunni/weapon.png'),
      role: 'https://static-jxqy.seasungames.cn/uploads/202504/1746017360494_yunni.png',
      pagination: require('./images/sect-yunni.png'),
      paginationAcitve: require('./images/sect-yunni-active.png'),
      videoUrl: ''
    },
    tangmen: {
      title: require('./images/tangmen/title.png'),
      subTitle: require('./images/tangmen/sub-title.png'),
      radar: require('./images/tangmen/radar.png'),
      desc: require('./images/tangmen/sect-desc.png'),
      weapon: require('./images/tangmen/weapon.png'),
      role: 'https://static-jxqy.seasungames.cn/uploads/202504/1746017360494_tangmen.png',
      pagination: require('./images/sect-tangmen.png'),
      paginationAcitve: require('./images/sect-tangmen-active.png'),
      videoUrl: ''
    },
    lieyu: {
      title: require('./images/lieyu/title.png'),
      subTitle: require('./images/lieyu/sub-title.png'),
      radar: require('./images/lieyu/radar.png'),
      desc: require('./images/lieyu/sect-desc.png'),
      weapon: require('./images/lieyu/weapon.png'),
      role: 'https://static-jxqy.seasungames.cn/uploads/202504/1746017360494_lieyu.png',
      pagination: require('./images/sect-lieyu.png'),
      paginationAcitve: require('./images/sect-lieyu-active.png'),
      videoUrl: ''
    },
    xuankong: {
      title: require('./images/xuankong/title.png'),
      subTitle: require('./images/xuankong/sub-title.png'),
      radar: require('./images/xuankong/radar.png'),
      desc: require('./images/xuankong/sect-desc.png'),
      weapon: require('./images/xuankong/weapon.png'),
      role: 'https://static-jxqy.seasungames.cn/uploads/202504/1746017360494_xuankong.png',
      pagination: require('./images/sect-xuankong.png'),
      paginationAcitve: require('./images/sect-xuankong-active.png'),
      videoUrl: ''
    }
  };
  @observable realIndex = 0;

  @computed
  get params() {
    const that = this;
    return {
      effect: 'fade',
      loop: true,
      on: {
        init: function() {
          that.swiperRef = this;
        },
        slideChangeTransitionEnd: function() {
          that.realIndex = this.realIndex;
          // that.realIndex = this.realIndex;
        }
      }
    };
  }

  changeSwiper = type => {
    if (type === 'prev') {
      this.swiperRef.slidePrev();
    } else if (type === 'next') {
      this.swiperRef.slideNext();
    } else {
      this.swiperRef.slideTo(type + 1);
    }
  };

  showSectPlay = url => {
    if (!url) {
      AntdMessage.info('敬请期待！');
      return;
    }
    Video.append({ src: url });
  };
  use() {
    super.use();

    useMount(async () => {});
  }
}

export default SectIntroductionStore;
